import { styled} from "@mui/material"
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
export const CustomBlueButton = styled(Button)(({ theme }) => ({
    color: "#fff",
    backgroundColor: "#00B4E5",
    '&:hover': {
      backgroundColor: "#00a6d3",
    },
    '&:disabled': {
      color: '#707070',
      backgroundColor: "#E5E5E5",
    },
    textTransform: "capitalize",
    fontSize: 14,
    borderRadius: "5px",
    cursor: "pointer",
    fontFamily: "Poppins-Regular",
    padding: "8px 15px",
}));
export const CustomGreyButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  backgroundColor: "#E5E5E5",
  '&:disabled': {
    color: '#707070',
    backgroundColor: "#E5E5E5",
  },
  textTransform: "capitalize",
  fontSize: 14,
  borderRadius: "5px",
  cursor: "pointer",
  fontFamily: "Poppins-Regular!important",
  padding: "8px 15px",
  border: "0px",
  color: '#707070'
}));

export const CustomBlueLink = (props) => {
    const {to, title, icon, href, target} = props
    const blueAStyle  = {
      textDecoration: "none",
      color: "#fff",
      backgroundColor: "#00B4E5",
      '&:hover': {
        backgroundColor: "#00a6d3",
      },
      textTransform: "capitalize",
      fontSize: 14,
      borderRadius: "5px",
      cursor: "pointer",
      fontFamily: "Poppins-Regular",
      padding: "9.8px 15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box"
    }
    if(href){
      return(
        <a href={to} target={target} style={{...blueAStyle, ...props.style}}>{icon}{title}</a>
      )
    } else {
      return(
        <Link to={to} style={{...blueAStyle, ...props.style}}>{icon}{title}</Link>
      )
    }
}
export const OutlinedButton = styled(Button)(({ theme }) => ({
    color: "#00B4E5",
    border: "1px solid #00B4E5",
    textTransform: "capitalize",
    '&:disabled': {
      border: "1px solid rgba(0, 0, 0, 0.26)",
    },
    fontSize: 14,
    borderRadius: "5px",
    cursor: "pointer",
    fontFamily: "Poppins-Regular",
    padding: "8px 15px",
    fontWeight: 400,
    boxSizing: "border-box",
    lineHeight: "unset"
}));
export const CustomOutlineLink = (props) => {
    const {to, title, icon, href, target} = props
    const blueAStyle  = {
      textDecoration: "none",
      color: "#00B4E5",
      border: "1px solid #00B4E5",
      backgroundColor: "#fff",
      textTransform: "capitalize",
      fontSize: 14,
      borderRadius: "5px",
      cursor: "pointer",
      fontFamily: "Poppins-Regular",
      padding: "9.8px 15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box"
    }
    if(href){
      return(
        <a href={to} style={{...blueAStyle, ...props.style}}>{icon}{title}</a>
      )
    } else {
      return(
        <Link 
          to={to}  
          {...(target ? { target, rel: "noopener noreferrer" } : {})} 
          style={{...blueAStyle, ...props.style}}>{icon}{title}
        </Link>
      )
    }
}
